// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ff06","footer":"styles_footer__xJlBa"};